<template>
  <div class="flex h-full w-16 absolute my-auto cursor-pointer">
    <div @click="prevCard('index')" class="w-16 h-16 my-auto">
      <img class="arrow-left cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-left.png" alt="arrow left">
    </div>
  </div>
</template>

<script>
export default {
  name: "PrevArrow",
  props:{
    prev:{
      required: true,
      type: String
    }
  },
  methods:{
    prevCard(){
      Event.$emit('clickedCard', this.prev);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
